module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_5.0d152523.png";